const job = {
  state: {
    // Holds the basic job details collected on the "Post Job" step
    // (postFreeJobs.vue) so the next step (DiscriptionJob.vue) can read
    // them and merge in the description/skills before the final POST.
    jobs: null,
  },
  mutations: {
    setJobs(state, jobs) {
      state.jobs = jobs;
    },
    clearJobs(state) {
      state.jobs = null;
    },
  },
  actions: {
    setJobs({ commit }, jobs) {
      commit("setJobs", jobs);
    },
    clearJobs({ commit }) {
      commit("clearJobs");
    },
  },
  getters: {
    getJobs: (state) => state.jobs,
  },
};

export default job;